<template>
  <b-modal
    ref="modalRelatorio"
    title="Relatório"
    title-class="font-weight: bold;"
    hide-footer
    size="lg"
    @close="onCloseRelatorio"
    @hidden="onCloseRelatorio"
  >
    <b-row v-if="info.relatorio">
      <b-col cols="3">
        <b-form-group label="Recurso">
          <b-form-input
            :value="info.recurso"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Evento">
          <b-form-input
            :value="info.tipo"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Usuário">
          <b-form-input
            :value="info.usuario"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Permissão do usuário">
          <b-form-input
            :value="info.permissoes.toString()"
            disabled
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="info.relatorio">
      <b-col cols="12">
        <legend class="col-form-label pt-0">
          Relatório
          <span
            v-if="info.podeSerInativado && info.tipo !== 'Processo realizado' && info.tipo !== 'Exclusão'"
            style="float: right !important;"
          >
            Registro:
            <span :class="['status-badge', {'badge badge-danger': !info.registroAtivo, 'badge badge-success': info.registroAtivo}]">
              {{ info.registroAtivo ? 'Ativo' : 'Inativo' }}
            </span>
          </span>
        </legend>
        <json-viewer
          :value="relatorio"
          :expand-depth="100"
          theme="json-theme"
          copyable
          boxed
          :preview-mode="false"
          :expanded="true"
        >
          <template
            slot="copy"
            slot-scope="{copied}"
          >
            {{ copied ? 'copiado!' : 'copiar' }}
          </template>
        </json-viewer>
      </b-col>
    </b-row>
  </b-modal>
</template>

<style lang="scss">
.status-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.json-theme {
  background: #fff;
  white-space: nowrap;
  color: #525252;
  font-size: 14px;
  font-family: Consolas, Menlo, Courier, monospace;

  .jv-ellipsis {
    color: #999;
    background-color: #eee;
    display: inline-block;
    line-height: 0.9;
    font-size: 0.9em;
    padding: 0px 4px 2px 4px;
    border-radius: 3px;
    vertical-align: 2px;
    cursor: pointer;
    user-select: none;
  }
  .jv-button { color: #49b3ff }
  .jv-key { color: #111111 }
  .jv-item {
    &.jv-array { color: #111111 }
    &.jv-boolean { color: #fc1e70 }
    &.jv-function { color: #067bca }
    &.jv-number { color: #067bca }
    &.jv-number-float { color: #067bca }
    &.jv-number-integer { color: #067bca }
    &.jv-object { color: #111111 }
    &.jv-undefined { color: #e08331 }
    &.jv-string {
      color: #42b983;
      word-break: break-word;
      white-space: normal;
    }
  }
  .jv-code {
    .jv-toggle {
      &:before {
        padding: 0px 2px;
        border-radius: 2px;
      }
      &:hover {
        &:before {
          background: #eee;
        }
      }
    }
  }
}
</style>

<script>
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'VisualizacaoRelatorio',
  components: {
    JsonViewer,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    relatorio: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    onCloseRelatorio() {
      this.$emit('close')
    },
  },
}
</script>
